export default __webpack_public_path__ + "static/media/premier-pro.e977114b.png";